import { render, staticRenderFns } from "./BetOddsSummaryMarketView.vue?vue&type=template&id=7055ce6b"
import script from "./BetOddsSummaryMarketView.vue?vue&type=script&lang=js"
export * from "./BetOddsSummaryMarketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports